export const parseError = (error: unknown, defaultMessage?: string) => {
  return error instanceof Error
    ? error.message
    : typeof error === 'string'
    ? error
    : defaultMessage ?? 'An error occured'
}
